export const ADD_ENTITY = 'ADD_ENTITY'
export const UPDATE_ENTITY = 'UPDATE_ENTITY'
export const STORE_COLLECTIONS = 'STORE_COLLECTIONS'